export const ROW_HEIGHT = 38.4;

export const FILTER_EDITOR_HEIGHT = 30;

export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_MIN_WIDTH = 50;

export const INHERIT_HEIGHT_MAX_ROWS = 30;

export const VIEWPORT_HEIGHT_RATIO = 0.83;

export const COMMAND_COLUMN_WIDTH = 44;

export const GROUP_INDENT_WIDTH = 32;

export const TREE_INDENT_WIDTH = 24;

export const TREE_TOGGLE_WIDTH = 24;

export const TREE_DRAG_THRESHOLD = 5;

export const TREE_TOUCH_DRAG_DELAY = 400;

export const ROW_BATCH_LIMIT = 1000;

export const HEADER_FILTER_TAKE = 500;

export const FILTER_ROW_DELAY = 500;

export const STATE_SAVING_DELAY = 500;

export const REMOVED_ROW_CLASS = "consuman-removed-row";

export const ROW_CONTROL_SELECTOR =
  "a[href], button, input, select, textarea, label, [role='button'], [role='checkbox'], [role='switch'], [role='radio'], [role='link'], [role='menuitem'], [role='option'], [role='combobox']";

export const DEFAULT_LOCALE = { decimalSeparator: ".", dateInputFormat: "DD/MM/YYYY" };

export const STRING_OPERATIONS = ["contains", "notcontains", "startswith", "endswith", "=", "<>"];

export const NUMBER_OPERATIONS = ["=", "<>", "<", ">", "<=", ">=", "between"];

export const DATE_OPERATIONS = ["=", "<>", "<", ">", "<=", ">=", "between"];

export const BOOLEAN_OPERATIONS = ["="];

export const FILTER_BUILDER_OPERATIONS = {
  string: ["contains", "notcontains", "startswith", "endswith", "=", "<>", "isblank", "isnotblank"],
  number: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank"],
  date: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank"],
  boolean: ["=", "<>", "isblank", "isnotblank"],
};

export const OPERATION_LABELS = {
  "=": "gridOperationEquals",
  "<>": "gridOperationNotEquals",
  "<": "gridOperationLess",
  ">": "gridOperationGreater",
  "<=": "gridOperationLessOrEquals",
  ">=": "gridOperationGreaterOrEquals",
  contains: "gridOperationContains",
  notcontains: "gridOperationNotContains",
  startswith: "gridOperationStartsWith",
  endswith: "gridOperationEndsWith",
  between: "gridOperationBetween",
  isblank: "gridOperationIsBlank",
  isnotblank: "gridOperationIsNotBlank",
  anyof: "gridOperationAnyOf",
  noneof: "gridOperationNoneOf",
};

export const OPERATION_ICONS = {
  "=": "mdi:equal",
  "<>": "mdi:not-equal-variant",
  "<": "mdi:less-than",
  ">": "mdi:greater-than",
  "<=": "mdi:less-than-or-equal",
  ">=": "mdi:greater-than-or-equal",
  contains: "mdi:magnify",
  notcontains: "mdi:magnify-remove-outline",
  startswith: "mdi:format-letter-starts-with",
  endswith: "mdi:format-letter-ends-with",
  between: "mdi:arrow-expand-horizontal",
};

export const DEFAULT_OPERATION = {
  string: "contains",
  number: "=",
  date: "=",
  datetime: "=",
  boolean: "=",
  object: "=",
};
